import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 w-full bg-brand-red z-50 py-2 px-4 shadow-lg" data-id="element-262">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center sm:space-x-4" data-id="element-263">
        <span className="text-white font-bold text-sm uppercase tracking-wider mb-1 sm:mb-0" data-id="element-264">
          Esta oferta termina pronto
        </span>
        <CountdownTimer size="sm" className="scale-90 sm:scale-100" data-id="element-265" />
      </div>
    </div>;
}